// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1g2wH","signatureButtonsRight":"ModalSign_signatureButtonsRight__3ThJH"};